import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }){
  const tokenKey = 'taskmate_token';
  const userKey = 'taskmate_user';
  const [token, setToken] = useState(localStorage.getItem(tokenKey));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem(userKey) || 'null'));

  const saveAuth = (t,u) => {
    if(t){
      localStorage.setItem(tokenKey, t);
    } else {
      localStorage.removeItem(tokenKey);
    }
    if(u){
      localStorage.setItem(userKey, JSON.stringify(u));
    } else {
      localStorage.removeItem(userKey);
    }
    setToken(t);
    setUser(u);
  };

  const logout = () => saveAuth(null, null);

  return <AuthContext.Provider value={{ token, user, saveAuth, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
